import script from "./ProfiloUtente.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfiloUtente.vue?vue&type=script&setup=true&lang=js"

import "./ProfiloUtente.vue?vue&type=style&index=0&id=1f840b5c&lang=scss&scoped=true"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f840b5c"]])

export default __exports__